export const parseJwt = (token: string) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

    const binaryString = window.atob(base64);
    const bytes = new Uint8Array(binaryString.length);

    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < binaryString.length; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    const decodedString = new TextDecoder().decode(bytes);
    return JSON.parse(decodedString);
  } catch (e) {
    return null;
  }
};
